/*
* CRM additional compass dependencies
* */
require('print-js')

$(document).ready(function () {
    /*
    * Components
    * */
    require('./components/relatable-side-panel')

    /*
    * Modules
    * */
    require('./modules/relations/form');
    require('./modules/addresses');
    require('./modules/relation-organisation-settings');
})
